<div class="d-flex justify-content-center align-items-center vh-100">
    <div class="card p-4" style="width: 300px;">
        <div class="text-center mb-4">
            <img src="zignflix_logo.png" alt="Application Name" class="logo-text">
            <br /><br />
            <h3 class="fw-600">Sign In</h3>
        </div>
        <form (ngSubmit)="login()">
            <div class="mb-3">
                <label for="email" class="form-label">Email</label>
                <input type="text" id="email" class="form-control" [(ngModel)]="email" name="username" required />
            </div>
            <div class="mb-3">
                <label for="password" class="form-label">Password</label>
                <input type="password" id="password" class="form-control" [(ngModel)]="password" name="password"
                    required />
            </div>
            <button type="submit" [disabled]="commonService.showSpinner" matButton class="w-100">
                @if (commonService.showSpinner) {
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                }
                @else {
                <span>Login</span>
                }
            </button>
        </form>
    </div>
</div>